/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

if (process.env.NODE_ENV == "DEVELOP" || process.env.NODE_ENV == "LOCAL") {
    require("./src/__mocks__")
}